import React from 'react'

interface Props {
  size?: number
  color?: string
  className?: string
}

// icon_chat_inspiration_zoom_light
const ChatInspirationZoomLightIcon: React.FC<Props> = ({
  size = 24,
  color = 'white',
  className = '',
}) => {
  return (
    <div style={{ width: size, height: size }} className={className}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          d="M5 14V19M10 19H5M5 19L10 14"
          stroke={color}
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 10V5M14 5H19M19 5L14 10"
          stroke={color}
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ChatInspirationZoomLightIcon
